export default __webpack_public_path__ + "static/overpass-bold-447b32a965d3b6ce022abe0fd420e6a4.woff2";